export default __webpack_public_path__ + "static/media/beep-sound.37488103.mp3";